//Why does this function exist? because you could do new URLSearchParams({ someList }) in JS runtime but typescript wont let you
export function createURLSearchParams(
	params: string[][] | Record<string, string | string[] | boolean> | string | URLSearchParams
): URLSearchParams {
	//@ts-ignore
	return new URLSearchParams(params);
}
